console.log("Tabletop Goodies - Script - Resources (EN)");

TTG.Resources.Strings.Languages = 
{
   "en": "English",
    "fr": "French",
     "es": "Spanish"
}

TTG.Resources.Strings.ColorNames = 
  {
    red: "Red",
    dark_red: "Dark Red",
    dark_orange: "Dark Orange",
    orange: "Orange",
    yellow: "Yellow",
    beige: "Beige",
    brown: "Brown",
    dark_green: "Dark Green",
    light_green: "Light Green",
    green: "Green",
    light_blue: "Light Blue",
    blue : "Blue",
    dark_blue: "Dark Blue",
    dark_purple: "Dark Purple",
    purple: "Purple",
    magenta: "Magenta",
    pink: "Pink",
    teal: "Teal",
    gray: "Gray",
    dark_gray: "Dark Gray",
    black: "Black",
    white: "White"
  };